import { APIWithoutURLBaseAndAuth } from './API';

const path = `escolas`;

const SchoolService = {
    //BUSCAR ESCOLA NA MIRIM
    buscarEscolaMirim: async filters => await APIWithoutURLBaseAndAuth.filters(`${process.env.REACT_APP_API_ESCOLAS_URL}/${path}` , filters),
}

export default SchoolService;